import { BaseLocation } from '../../../../shared/models/baseLocation';
import { Location } from '../../../../shared/models/location';
import { Machine } from '../../../../shared/models/machine';
import { Navigation } from '../../../../shared/models/navigation';
import { Operation } from '../../../../shared/models/operation';
import { Telemetry } from '../../../../shared/models/telemetry';
import { OpType, OperationType } from '../enums/operation-type.enum';

export class DeviceInfoModel {
  constructor(
    public deviceId: string = 'Default Id',
    public gateway: string = 'Default Id',
    public deviceStatus: RealtimeDeviceStatus = RealtimeDeviceStatus.OFFLINE,
    public secArray?: any,
    public opType: OperationType = OpType.SPRAYING,
    public implWidth: number = 0,
    public instRate: number = 0,
    public instRateUnit: string = '',
    public latitude: number = 0,
    public longitude: number = 0,
    public timestamp: number = 0,
    public secState: string = 'Default Section State',
    public speed: number = 0,
    public isIsobusDeviceChanged: boolean = false,
  ) {}
}

export interface DeviceDTO {
  deviceId: string;
  location: { elevation: number; latitude: number; longitude: number };
  timestamp: string;
  workStatus: string;
  deviceType?: string;
  name?: string;
  onboarded?:boolean;
}

export interface DeviceInfo {
  deviceId: string;
  deviceStatus: RealtimeDeviceStatus;
}

export interface RealtimeDevice extends DeviceDTO {
  status: RealtimeDeviceStatus;
}

export enum RealtimeDeviceStatus {
  OFFLINE,
  MOVING,
  WORKING,
}

export class DeviceMessageModel {
  constructor(
    public d: DynamicMessageModel = new DynamicMessageModel(),
    public e: StaticMessageModel = new StaticMessageModel(),
    public id: string = 'Default Id',
    public location: Location = new Location(),
  ) {}
}

export class DynamicMessageModel {
  constructor(
    public id: string = 'Default Id',
    public gw_addr: string = 'Default gw_addr',
    public deviceId: string = 'Default Device Id',
    public node_addr: string = 'Default Node Address',
    public location: Location = new Location(),
    public operation: Operation = new Operation(),
    public machine: Machine = new Machine(),
    public navigation: Navigation = new Navigation(),
    public telemetry: Telemetry = new Telemetry(),
    public base_location: BaseLocation = new BaseLocation(),
    public timestamp: number = 0,
  ) {}
}

export class StaticMessageModel {
  constructor(
    public machine_name: string = 'Default Machine Name',
    public impl_width: number = 0,
    public timestamp: number = 0,
    public node_addr: string = 'Default Node Address',
    public app_version: string = 'Default App Version',
    public crop_timestamp: number = 0,
    public nozz_number: string = 'Default Nozzle Number',
    public field_name: string = 'Default Field Name',
    public machine_model: number = 0,
    public operator: string = 'Default Operator',
    public gw_addr: string = 'Default Gateway Address',
    public crop_type: string = 'Default Crop Type',
    public manufacturer: string = 'Default Manufacturer',
    public sec_number: string = 'Default Section Number',
    public event_name: string = 'Default Event Name',
    public nozz_spacing: number = 0,
    public nozz_per_section: Array<number> = [0],
    public crop_location: {
      crop_lat: number;
      crop_lon: number;
    } = { crop_lat: 0, crop_lon: 0 },
  ) {}
}

export function convertToRealtimeStatus(status: string) {
  if (status === 'Working') return RealtimeDeviceStatus.WORKING;
  if (status === 'Not_Working') return RealtimeDeviceStatus.MOVING;
  else return RealtimeDeviceStatus.OFFLINE;
}
